import * as sentry from 'utilities/sentry';

import acceptSelfServeBetaInvite from './AcceptSelfServeBetaInvite.gql';
import { MAP_KEY_TO_STEP, MAP_SCREEN_STEP_KEY_TO_COMPONENT } from './constants';
import { getGraphQLClient } from '../../utilities/graphql';

export const getStepComponentFromKey = stepKey => {
  return MAP_SCREEN_STEP_KEY_TO_COMPONENT[stepKey];
};

export const markSelfServeInviteAsAccepted = async email => {
  const client = getGraphQLClient();

  try {
    const { data } = await client.mutate({
      mutation: acceptSelfServeBetaInvite,
      variables: {
        email,
      },
    });

    return data.success;
  } catch (err) {
    sentry.logException(err, 'Error accepting self serve beta invite');
  }
};

export const getStepsFromKey = stepKey => {
  return MAP_KEY_TO_STEP[stepKey];
};
